import { IWorkOrderAdapter } from './IWorkOrderAdapter';
import { ApiResponse } from '../../types/api';
import { WorkOrder, CreateWorkOrderDto, WorkOrderFilter } from '../../types/workOrder';
import { ApiClient } from '../apiClient';

export class LaravelWorkOrderAdapter implements IWorkOrderAdapter {
  async getWorkOrders(filter?: WorkOrderFilter): Promise<ApiResponse<WorkOrder[]>> {
    const params = new URLSearchParams(filter as any).toString();
    return ApiClient.get<WorkOrder[]>(`/api/v1/work-orders?${params}`);
  }

  async getWorkOrderById(id: string): Promise<ApiResponse<WorkOrder>> {
    return ApiClient.get<WorkOrder>(`/api/v1/work-orders/${id}`);
  }

  async createWorkOrder(dto: CreateWorkOrderDto): Promise<ApiResponse<WorkOrder>> {
    return ApiClient.post<WorkOrder>('/api/v1/work-orders', dto);
  }

  async updateStatus(id: string, status: WorkOrder['status']): Promise<ApiResponse<WorkOrder>> {
    return ApiClient.post<WorkOrder>(`/api/v1/work-orders/${id}/status`, { status });
  }
}
